export const org_duty = {
	1: { name: 'ผู้กำหนดสิทธิ์', value: 1 },
	2: { name: 'ผู้เตรียมข้อมูล', value: 2 },
	3: { name: 'ผู้อนุมัติการส่งข้อมูล', value: 3 },
}
